import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html'
})
export class FileUploadComponent {
  selectedFiles: File[] = [];
  @ViewChild('inputFile') inputFile!: ElementRef;

  constructor(private http: HttpClient) { }
  
  // Método para capturar os arquivos selecionados
  onFilesSelected(event: any) {
      this.selectedFiles = [...this.selectedFiles, ...Array.from(event.target.files)] as File[];
  }

  // Método de envio dos arquivos um a um
  sendUploadedFiles(idReport: number) {
    if (this.selectedFiles.length === 0) {
      console.error('Nenhum arquivo selecionado!');
      return;
    }


    this.selectedFiles.forEach((file) => {
      const formData = new FormData();
      formData.append('file', file);

      // Headers opcionais (multipart já cuida da configuração do content-type)
      const headers = new HttpHeaders();

      // Fazer o upload do arquivo individualmente
      this.http.post(`/api/v1/sr/${idReport}/attachment`, formData, { headers, withCredentials: true })
        .subscribe({
          next: (response) => {
            console.log(`Upload do arquivo ${file.name} feito com sucesso!`, response);
          },
          error: (error) => {
            console.error(`Erro no upload do arquivo ${file.name}`, error);
          }
        }
        );
    });
  }

  resetField(){
    // this.inputFile.nativeElement.value = '';
    // this.selectedFiles = [];
  }

  remove(index: number) {
    this.selectedFiles.splice(index, 1);
  }
}
